/*
 * @Author: cc
 * @Date: 2020-07-23 13:46:35
 * @LastEditTime: 2020-08-31 14:46:33
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\newspaper\newspaper.js
 * @Description: 
 */
'use strict';
angular.module('editingCenterNewspaperModule', [
    'editingCenterNewspaperRouterModule',
    'newspaperPageDraftModule',
    'newspaperSampleReviewModule',
    'newspaperSignedDraftModule',
    'newspaperStandbyDraftModule',
    'newspaperTodaysDraftModule',
    'ediCtrNewspaperShangbanModule',
    'changeAllLayoutModule',
    'editNewspaperServiceModule',
    'editNewspapaerSignedZPModule',
    'editingCenterNewspaperPreviewRouterModule',
    'editctrNewspaperEditModule',
    'editNewspapaerUseSignedZPModule',
    'newsDictionBtnServiceModule',
    'newsEditBtnModule',
    'editctrInitBtnModule',
    'newspaperPreviewModule',
    'newspaperArchiveDraftRouterModule',
    'initPaperDataModule',
]).controller('EditingCenterNewspaperController', [function() {
    // 
}]);
